if ($('body').hasClass('home')) {
  // ---------------------------------------------------------------------------
  // トップのバナースライダー
  // ---------------------------------------------------------------------------
  var carousel = new Swiper('.carousel .swiper-container', {
    loop: true,
    speed: 400,
    autoplay: { // https://idangero.us/swiper/api/#autoplay
      delay: 3000,
      waitForTransition: true,
    },
    pagination: { // https://idangero.us/swiper/api/#pagination
      el: '.swiper-pagination',
      dynamicBullets: false,
    },
    navigation: { // https://idangero.us/swiper/api/#navigation
      nextEl: '.carousel-button-next',
      prevEl: '.carousel-button-prev'
    },
    // https://idangero.us/swiper/api/#lazy
    preloadImages: false,
    lazy: false
  });

  // carousel.autoplay.stop();

  // ---------------------------------------------------------------------------
  // トップのタブメニューの要素
  // ---------------------------------------------------------------------------

  var $tabItems = $('.tabby-top .swiper-slide');
  var $cardOriginals = $('.tabby-bottom .swiper-slide:not([class*="duplicate"])');
  var $cardList = $('.tabby-bottom .swiper-slide');
  var $bigTabWrap = $('.tab-table');
  var $bigTabs = $bigTabWrap.find('.tab-table__item');

  // ---------------------------------------------------------------------------
  // 普通のブラウザー(IE以外)の設定
  // ---------------------------------------------------------------------------

  // IEでは自動的に設定されたタブの横幅から合計を計算できない為
  // IEだけでは小タブの横幅を固定に設定する
  var tabbyTopSlidesPerView;

  ieUser
    ? tabbyTopSlidesPerView = 4
    : tabbyTopSlidesPerView = 'auto';

  if (!ieUser) {

    // 小タブの固定設定
    var tabbySticky = stickybits('#tabby-top-stick', {
      stickyBitStickyOffset: $('.global-menu__upper').height() + $('.tab-table').height() + 13,
      useStickyClasses: true
    });

    // 大タブの固定設定
    var tabMenuSticky = stickybits('.tab-table', {
      stickyBitStickyOffset: $('.global-menu__upper').height(),
      useStickyClasses: true
    });

    // コンテンツの矢印ボタンの固定設定
    var tabbyArrowsSticky = stickybits('.tabby-buttons', {
      stickyBitStickyOffset: window.innerHeight / 2,
      useStickyClasses: true,
    });

  } // IE以外ブラウザー条件終了

  // ---------------------------------------------------------------------------
  // トップのタブスライダー（上の小タブ）
  // スライダーの設定方法はこちら ➔ http://idangero.us/swiper/api/
  // ---------------------------------------------------------------------------

  var tabbyTop = new Swiper ('.tabby-top.swiper-container', {
    loop: false,
    slidesPerView: tabbyTopSlidesPerView,
    freeMode: true,
    grabCursor: true,
    spaceBetween: 0,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    on: {
      tap: function(event) {
        // 選択されてないタブをタップしたら下のスライダーを動かす
        if (this.clickedIndex !== tabbyBottom.activeIndex &&
            $(this.clickedSlide).data('tag') !== $(tabbyBottom.slides[tabbyBottom.activeIndex]).data('tag')
          ) {
          tabbyBottom.slideTo(this.clickedIndex);
        }

        // クリックした小タブの種類を変数として設定する
        var clickedType = $(this.clickedSlide).data('type');
        var currentlyActiveClassName = 'js-type-visible';

        // 大タブにクリックした小タブの種類のクラス名をつける（不要クラスも取り去る）
        $bigTabs.each(function(index, bigTab) {
          if ($(bigTab).data('tab-link') === clickedType) {
            $(bigTab).addClass(currentlyActiveClassName);
          } else {
            $(bigTab).removeClass(currentlyActiveClassName);
          }
        });

        // クリックした小タブの種類が今選択された大タブと違うなら取り去って新規クラスをつける
        if (!$bigTabWrap.hasClass('js-' + clickedType)) {
          $bigTabWrap
            .removeClass(function(index, css) {
              return (css.match (/js-\S+/g) || []).join(' '); // 「js-」から始まるクラスを削除
            })
            .addClass('js-' + clickedType);
        }
      }
    }
  });

  // ---------------------------------------------------------------------------
  // トップのタブスライダー（下のコンテンツ）
  // ---------------------------------------------------------------------------

  var tabbyBottom = new Swiper ('.tabby-bottom.swiper-container', {
    autoHeight: true,
    loop: false,
    spaceBetween: 10,
    navigation: {
      nextEl: '.tabby-button-next',
      prevEl: '.tabby-button-prev'
    },
    on: {
      slideChangeTransitionStart: function() {
        // スライドが変わったタイミングでスライダーを画面の上部にスクロールする
        $.smoothScroll({
          scrollElement: null, // $('html, body').firstScrollable() - https://github.com/kswedberg/jquery-smooth-scroll#additional-option
          offset: ($('.global-menu__upper').height() + 8) * -1, // https://github.com/kswedberg/jquery-smooth-scroll#fnsmoothscroll
          scrollTarget: '#tabby-top-stick-wrap', // この要素までスクロールする
          speed: 300,
        });
     
        // 以前選択されたタブの「active」クラスを取り去ってクリックしたタブに「active」クラスをつける
        $('.tabby-top .active').removeClass('active');
        $(tabbyTop.slides[this.activeIndex]).addClass('active');
      }
    }
  });

  tabbyBottom.controller.control = tabbyTop;
}
